import React, { useEffect } from "react"
import { Button, Divider, Grid, styled, Theme, Typography, useMediaQuery, useTheme } from "@mui/material"
import { Choice } from "models/Choice"

const StyledContainer = styled(Grid)(({ theme }: { theme: Theme }) => ({
  borderRadius: 8,
  minHeight: 75,
  border: "none",
  cursor: "pointer",
  backgroundColor: theme.palette.primary.main
}))

const Text = styled(Typography)({
  fontWeight: 300
})

const StyledButton = styled(Button)({
  "width": "100%",
  "minHeight": "inherit",
  "&:hover": {
    background: "#2d433c"
  }
})

export const ChoiceItemSelected: React.FC<{
  choice: Choice
  setSelectedVotes: any
  votes: Choice[]
  multiple: boolean
}> = ({ choice, setSelectedVotes, votes, multiple }) => {
  const theme = useTheme()
  const isMobileSmall = useMediaQuery(theme.breakpoints.down("lg"))

  const handleVotes = (choice: Choice) => {
    if (multiple) {
      let votesArray = [...votes]
      if (!votesArray.includes(choice)) {
        votesArray?.push(choice)
      } else {
        votesArray = votesArray.filter(vote => vote._id !== choice._id)
      }
      const result = votesArray.map(vote => {
        vote.selected = true
        return vote
      })
      setSelectedVotes(result)
    } else {
      choice.selected = true
      setSelectedVotes([choice])
    }
  }

  const isPartOfVotes = () => {
    const found = votes.filter(vote => vote._id === choice._id)
    return found.length > 0
  }

  return (
    <StyledContainer
      spacing={isMobileSmall ? 1 : 2}
      container
      item
      style={
        isPartOfVotes()
          ? {
              border: "1px solid",
              borderColor: "#2D433C",
              backgroundColor: "#334d43"
            }
          : {}
      }
      xs={isMobileSmall ? 12 : 6}
      justifyContent={"center"}
      alignItems="center"
    >
      <StyledButton
        onClick={() => {
          handleVotes(choice)
          return
        }}
      >
        <Text color="textPrimary">{choice.name}</Text>
      </StyledButton>
    </StyledContainer>
  )
}
